<!--
 * @Author: xuesong
 * @Date: 2021-04-26 11:48:19
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-05-11 19:15:17
 * @Description:  16 医生端发送的语音消息
-->
<template>
  <div class="custom-16" :style="{ backgroundColor: bgColor, color: color }">
      <!-- <div>语音{{data}}</div> -->
      <div class="info" @click="playMyAudio(data.url)">
      <!-- <i class="el-icon-headset" style="font-size:20px"></i> -->
      <div>
        <img src="../../static/IM/audio.png" alt="" />
      </div>
      <div>{{ data.second }}s</div>
      <!-- <audio :src="data | assembleImgSrc" controls style="height:40px" ></audio> -->
    </div>
  </div>
</template>

<script>
export default {
  props:{
    data:{
      type: Object,
      default: ()=>{}
    },
    bgColor: {
      type: String,
      default: '#F5F5F5',
    },
    color: {
      type: String,
      default: '#333',
    },
  },
  data() {
    return {
      audio: null,
    }
  },
  methods: {
    playMyAudio(item, index) {
      item = item ? `${process.env.VUE_APP_OSS_URL}` + item : ''
      if (this.audio) {
        this.audio.pause()
        this.audio = null
      }

      this.audio = new Audio(item)
      this.audio.play()
      this.audio.addEventListener(
        'ended',
        () => {
          //监听是否播放完毕
          this.isPlay = false
          this.playCount = 0
        },
        false
      )
    },
  },
}
</script>

<style scoped lang="less">
.custom-16{
  border-radius: 4px;    
  padding: 10px;
  cursor: pointer;

  .info {
    display: flex;

    align-items: center;
  }

  // justify-content: center;
  img {
    width: 14px;
    height: 16px;
    margin-right: 10px;
  }
}
</style>